import {IsEnum, IsNotEmpty, MaxLength, ValidateNested} from "class-validator";
import {PersonaTheme} from "../../enums/personaTheme.enum";
import {UserCategoryResult} from "./UserCategoryResult.model";
import CategoryAnswer from "../answer/categoryAnswer.model";
import {InputConstants} from "../../constants/input.constants";

class PersonaEditModel {

    @IsNotEmpty({message: "Please enter a title"})
    @MaxLength(InputConstants.ProfileTitleLength)
    displayName: string;

    @IsNotEmpty({message: "Select an option"})
    @IsEnum(PersonaTheme)
    theme: PersonaTheme;

    answers: {
        [key: string] : CategoryAnswer;
    };
}

export { PersonaEditModel }